import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API_BASE from "../config/api";

const checkImageExists = (url) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = url;
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
    });
};

function BusinessProfile() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [profileImage, setProfileImage] = useState("");

    // 1️⃣ Fetch data
    useEffect(() => {
        fetch(`${API_BASE}/api/businessProfiledata.php?id=${id}`)
            .then((res) => res.json())
            .then((result) => setData(result.data))
            .catch((err) => console.log(err));
    }, [id]);

    // 2️⃣ Process image after data loads
    useEffect(() => {
        const defaultPath = `${API_BASE}/uploads/default.png`;

        if (!data) return;

        // If no image name → directly set default
        if (!data.profilepics) {
            setProfileImage(defaultPath);
            return;
        }

        const imagePath = `${API_BASE}/uploads/${data.profilepics}`;

        checkImageExists(imagePath).then((exists) => {
            setProfileImage(exists ? imagePath : defaultPath);
        });
    }, [data]);

    // 3️⃣ Rendering
    if (!data) {
        return <div className="text-center py-5">Loading...</div>;
    }

    return (
        <div className="container my-4">

            {/* PROFILE PIC */}
            <div className="text-center mb-4">
                <img
                    src={profileImage}
                    alt="profile"
                    className="rounded-circle border border-3"
                    style={{
                        width: "250px",
                        height: "250px",
                        objectFit: "cover",
                        marginTop: "20px",
                    }}
                />

                <h3 className="fw-bold mt-3 mb-1">
                    {data.name || "Business Name"}
                </h3>

                <p className="text-muted small">
                    <i className="bi bi-geo-alt-fill text-primary me-1"></i>
                    {data.address || "Location not available"}
                </p>

            </div>

            {/* ABOUT */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-2">About</h5>
                <p className="text-muted">
                    {data.about ||
                        "This business provides premium services with excellent customer satisfaction."}
                </p>
            </div>

            {/* FACILITIES */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Facilities</h5>
                <div className="d-flex flex-wrap gap-2">
                    {(data.facilities || []).map((item, index) => (
                        <span key={index} className="badge bg-light text-dark">
                            {item}
                        </span>
                    ))}
                </div>
            </div>

            {/* CONTACT INFORMATION */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Contact Information</h5>

                <ul className="list-unstyled">
                    <li className="mb-2">
                        <i className="bi bi-telephone-fill text-success me-2"></i>
                        {data.phone}
                    </li>
                    <li className="mb-2">
                        <i className="bi bi-envelope-fill text-danger me-2"></i>
                        {data.email}
                    </li>
                    <li>
                        <i className="bi bi-globe text-primary me-2"></i>
                        {data.website}
                    </li>
                </ul>
            </div>

            {/* MAP PLACEHOLDER */}
            {/* MAP SECTION */}
            {/* MAP SECTION */}
            <div className="card border-0 shadow-sm p-4 mb-4">
                <h5 className="fw-bold mb-3">Location Map</h5>

                {data.latitude && data.longitude ? (
                    <iframe
                        width="100%"
                        height="300"
                        style={{ border: 0, borderRadius: "10px" }}
                        loading="lazy"
                        allowFullScreen
                        src={`https://www.google.com/maps?q=${data.latitude},${data.longitude}&z=15&output=embed`}
                    ></iframe>
                ) : (
                    <div
                        className="bg-light rounded d-flex justify-content-center align-items-center"
                        style={{ height: "250px" }}
                    >
                        <p className="text-muted">Location not available</p>
                    </div>
                )}
            </div>



        </div>
    );
}

export default BusinessProfile;
